export default __webpack_public_path__ + "static/slider-bus-f828387ecf770e17541284efa80c88bb.png";